/**
 * AlmadarPostAgenticSearchSLPostPageView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait AlmadarPostAgenticSearchSLPostPage
 */

import { useAlmadarPostAgenticSearchSLPostPageLogic } from '@/hooks/traits/useAlmadarPostAgenticSearchSLPostPageLogic';
import type { AlmadarPostAgenticSearchSLPostPageConfig } from '@/hooks/traits/useAlmadarPostAgenticSearchSLPostPageLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { AlmadarPostAgenticSearchSLPostView as AlmadarPostAgenticSearchSLPostViewEntity } from '@app/shared';
import { AlmadarPostAgenticSearchSLPostView } from '@/components/traits/AlmadarPostAgenticSearchSLPostView';
import { AlmadarPostAgenticSearchSLPostFooterView } from '@/components/traits/AlmadarPostAgenticSearchSLPostFooterView';
import { AlmadarPostAgenticSearchSLPostHeaderView } from '@/components/traits/AlmadarPostAgenticSearchSLPostHeaderView';
import { Stack } from '@almadar/ui/components';
import { Box } from '@almadar/ui/components';
import { Container } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface AlmadarPostAgenticSearchSLPostPageViewProps {
  config?: Partial<AlmadarPostAgenticSearchSLPostPageConfig>;
}

export function AlmadarPostAgenticSearchSLPostPageView({ config: propsConfig }: AlmadarPostAgenticSearchSLPostPageViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useAlmadarPostAgenticSearchSLPostPageLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['AlmadarPostAgenticSearchSLPostView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="AlmadarPostAgenticSearchSL" trait="AlmadarPostAgenticSearchSLPostPage">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="AlmadarPostAgenticSearchSLPostPage">{slotWriter['main'] === 'INIT' ? (<Stack gap="none" direction="vertical"><AlmadarPostAgenticSearchSLPostHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><Box bg="transparent" fullWidth={true} paddingY="xl"><Container padding="lg" size="xl" maxWidth="xl"><AlmadarPostAgenticSearchSLPostView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Container></Box><AlmadarPostAgenticSearchSLPostFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default AlmadarPostAgenticSearchSLPostPageView;
